module.exports = "<h2 id=\"component-description\">Component description</h2>\n<p>A dropdown container. Literally just the container. Two flavors: regular and\nwith error.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Dropdown/README.md
// module id = 347
// module chunks = 0